import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../Layout/Grid/Cell/Default/EnumCell";
import { routeStateAsString } from "../../Project/ViewModel/RouteState";

export const routeStateTypeEnumCell = (props: GridCellProps) => {
  return <EnumerationCell {...props} mapping={routeStateAsString} />;
};

export const routeStateTypeColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { Status: "Sandbox" },
      { Status: "NWP Recheck" },
      { Status: "Plant Confirmation" },
      { Status: "ODC Confirmation" },
      { Status: "Supplier Confirmation" },
      { Status: "Carrier Confirmation" },
      { Status: "Carrier Manager" },
      { Status: "Ready For Launch" },
      { Status: "Launched" },
      { Status: "Pending Launch" },
      { Status: "Re-Launch" },
      { Status: "Interim Launch" },
      { Status: "De-Launched" },
    ]}
    searchBox={() => null}
    {...props}
  />
);
